<h2>PostalCode Mapping</h2>

<div class="px-2 py-3 contents h-full max-h-80" *ngIf="isLoadPostalCodeMappingGridDataSource">
    <div class="flex pb-4 justify-start">
        <dx-check-box [value]="false" text="Include deactivated Postal Code Mapping items" class="pr-2" (onValueChanged)="extraFilteringOptionsChange('Active', $event)"></dx-check-box>
    </div>
    <div class="mapping-grid-container shadow-lg">
        <dx-data-grid #postalCodeMappingDataGrid id="gridContainer"
                      [allowColumnResizing]="true"
                      [columnResizingMode]="'widget'"
                      [allowColumnReordering]="true"
                      [dataSource]="postalCodeMappingDataSource"
                      [showBorders]="true"
                      [columnAutoWidth]="true"
                      [remoteOperations]="true"
                      [hoverStateEnabled]="true"
                      (onSelectionChanged)="mappingGridSelectionChangedHandler()"
                      (onContentReady)="onReady($event)"
                      (onContextMenuPreparing)="postalCodeMappingDataContextMenu($event)"
                      [cacheEnabled]="false"
                      keyExpr="PostalCodeMappingId">
            <dxo-state-storing
                    [enabled]="true"
                    type="custom"
                    [customLoad]="loadMappingState"
                    [customSave]="saveMappingState">
            </dxo-state-storing>
            <dxo-sorting mode="single"></dxo-sorting>
            <dxo-filter-panel [visible]="true"></dxo-filter-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
            <dxo-selection mode="single"></dxo-selection>
            <dxo-load-panel
                    [enabled]="false"
                    shadingColor="rgba(0,0,0,0.4)"
                    [showIndicator]="true"
                    [showPane]="true"
                    [shading]="true">
            </dxo-load-panel>
            <dxo-column-chooser
                    [enabled]="true"
                    mode="dragAndDrop"> <!-- or "select" -->
            </dxo-column-chooser>
            <dxo-pager
                    [visible]="true"
                    [allowedPageSizes]="[5, 10, 25, 50, 100]"
                    displayMode="compact"
                    [showPageSizeSelector]="true"
                    [showNavigationButtons]="false"
            >
            </dxo-pager>

            <dxi-column dataField="PostalCodeMappingId" [allowHeaderFiltering]="false" [width]="140" caption="PostalCode Mapping Id" [customizeText]="customizePostalCodeMappingId"></dxi-column>
            <dxi-column caption="Action" [allowHeaderFiltering]="false" cellTemplate="action" alignment="center"></dxi-column>
            <dxi-column caption="Source Data">
                <dxi-column dataField="SourceCountry" caption="Country" [allowHeaderFiltering]="true">
                    <dxo-header-filter [dataSource]="sourceCountryHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SourceCountrySubdivision" caption="Country Subdivision" [allowHeaderFiltering]="true">
                    <dxo-header-filter [dataSource]="sourceCountrySubdivisionHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SourcePostalCode" caption="Postal Code" [allowHeaderFiltering]="true">
                    <dxo-header-filter [dataSource]="sourcePostalCodeHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SourcePostalSystemGeographicalEntityId" caption="Postal System Country Id" [visible]="true">
                    <dxo-header-filter [dataSource]="sourcePostalSystemGeographicalEntityIdHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>
            <dxi-column caption="Data Provider">
                <dxi-column dataField="DataProviderCode" caption="Code" [allowHeaderFiltering]="true">
                    <dxo-header-filter [dataSource]="dataProviderCodeHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="DataProviderPrimaryOrDefaultCountryGeographicalEntityShortName" caption="Default Country" [allowHeaderFiltering]="true">
                    <dxo-header-filter [dataSource]="dataProviderPrimaryOrDefaultCountryGeographicalEntityShortNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="DataProviderPrimaryOrDefaultCountryGeographicalEntityCountryAlpha2Code" caption="Country Code" [allowHeaderFiltering]="true">
                    <dxo-header-filter [dataSource]="dataProviderPrimaryOrDefaultCountryGeographicalEntityCountryAlpha2CodeHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="IsDataProviderPrimaryOrDefaultCountryInconsistentMappingMessage" caption="Inconsistent Mapping" [allowHeaderFiltering]="true">
                    <dxo-header-filter [dataSource]="isDataProviderPrimaryOrDefaultCountryInconsistentMappingMessageHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>
            <dxi-column dataField="MappingModeKey" [visible]="true">
                <dxo-header-filter [dataSource]="mappingModeKeyHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="MappingModeName" [allowHeaderFiltering]="true">
                <dxo-header-filter [dataSource]="mappingModeNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column caption="Mapped To">
                <dxi-column dataField="PostalCodeMasterId" caption="Master Id" [allowHeaderFiltering]="true">
                    <dxo-header-filter [dataSource]="postalCodeMasterIdHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="PostalSystemOrCountryLevelGeographicalEntityMismatchError" caption="Postal System Country Mismatch" [allowHeaderFiltering]="true">
                    <dxo-header-filter [dataSource]="postalSystemOrCountryLevelGeographicalEntityMismatchErrorHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="PostalCodeBaseLevelGeographicalEntityMismatchError" caption="Postal Code Country Subdivision Mismatch" [allowHeaderFiltering]="true">
                    <dxo-header-filter [dataSource]="postalCodeBaseLevelGeographicalEntityMismatchErrorHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionTypeName" [visible]="true">
                <dxo-header-filter [dataSource]="countrySubdivisionTypeNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionShortName" [visible]="true">
                <dxo-header-filter [dataSource]="countrySubdivisionShortNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionParentTypeName" [visible]="true">
                <dxo-header-filter [dataSource]="countrySubdivisionParentTypeNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionParentShortName" [visible]="true">
                <dxo-header-filter [dataSource]="countrySubdivisionParentShortNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionParentCode" [visible]="true">
                <dxo-header-filter [dataSource]="countrySubdivisionParentCodeHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionMappingModeName" [visible]="true">
                <dxo-header-filter [dataSource]="countrySubdivisionMappingModeNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionMappingModeKey" [visible]="true">
                <dxo-header-filter [dataSource]="countrySubdivisionMappingModeKeyHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionCountryAlpha2Code" [visible]="true">
                <dxo-header-filter [dataSource]="countrySubdivisionCountryAlpha2CodeHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionCode" [visible]="true">
                <dxo-header-filter [dataSource]="countrySubdivisionCodeHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountryShortName" [visible]="true">
                <dxo-header-filter [dataSource]="countryShortNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountryMappingModeName" [visible]="true">
                <dxo-header-filter [dataSource]="countryMappingModeNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountryMappingModeKey" [visible]="true">
                <dxo-header-filter [dataSource]="countryMappingModeKeyHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountryAlpha2CodeMismatchError" [visible]="true">
                <dxo-header-filter [dataSource]="countryAlpha2CodeMismatchErrorHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountryAlpha2Code" [visible]="true">
                <dxo-header-filter [dataSource]="countryAlpha2CodeHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CleanPostalCode" [allowHeaderFiltering]="true">
                <dxo-header-filter [dataSource]="cleanPostalCodeHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="IsValidPostalCode" [allowHeaderFiltering]="true"></dxi-column>
            <dxi-column dataField="SourceCountrySubdivisionMappingId" [visible]="true">
                <dxo-header-filter [dataSource]="sourceCountrySubdivisionMappingIdHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="SourceCountryMappingId" [visible]="true">
                <dxo-header-filter [dataSource]="sourceCountryMappingIdHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionMappingModeId" [visible]="true">
                <dxo-header-filter [dataSource]="countrySubdivisionMappingModeIdHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountrySubdivisionGeographicalEntityId" [visible]="true">
                <dxo-header-filter [dataSource]="countrySubdivisionGeographicalEntityIdHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="CountryGeographicalEntityId" [visible]="true">
                <dxo-header-filter [dataSource]="countryGeographicalEntityIdHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column caption="Data Auditing">
                <dxi-column dataField="ModifiedByUserFullNameSortableOrPrincipalName" caption="Modified by" [allowHeaderFiltering]="true">
                    <dxo-header-filter [dataSource]="modifiedByUserFullNameSortableOrPrincipalNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedOn" cssClass="hide-filter-icon" caption="Modified On" [visible]="true" format="d/M/yyyy, HH:mm" dataType="datetime" [customizeText]="dateTimeFieldCustomization">
                    <dxo-header-filter [dataSource]="modifiedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedByUserFullNameSortableOrPrincipalName" caption="Reviewed by" [allowHeaderFiltering]="true">
                    <dxo-header-filter [dataSource]="reviewedByUserFullNameSortableOrPrincipalNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedOn" cssClass="hide-filter-icon" caption="Reviewed on" [visible]="true" format="d/M/yyyy, HH:mm" dataType="datetime" [customizeText]="dateTimeFieldCustomization">
                    <dxo-header-filter [dataSource]="reviewedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CreatedOn" dataType="date" format="d/M/yyyy, HH:mm" dataType="datetime" cssClass="hide-filter-icon" [customizeText]="dateTimeFieldCustomization" [visible]="true">
                    <dxo-header-filter [dataSource]="createdOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CreatedByUserFullNameSortableOrPrincipalName" caption="Created by" [visible]="true">
                    <dxo-header-filter [dataSource]="createdByUserFullNameSortableOrPrincipalNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>
            <dxi-column dataField="MappingModeName" caption="Mapping Mode Name" [allowHeaderFiltering]="false" [allowFiltering]="false">
            </dxi-column>
            <dxi-column dataField="MappingModeId" caption="Mapping Mode" [alignment]="'left'">
                <dxo-header-filter [dataSource]="mappingModeNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="Active" caption="Is Active" [visible]="true"></dxi-column>
            <div *dxTemplate="let action of 'action'">
<!--                <dx-button class="mr-1" icon="fas fa-ban fa-1x" hint="Omit" [disabled]="action?.data?.MappingModeId == 3" (onClick)="omit(action?.data?.PostalCodeMappingId)"></dx-button>-->
<!--                <dx-button class="mr-1" icon="far fa-bookmark fa-1x" hint="Save" [disabled]="action?.data?.MappingModeId == 2" (onClick)="save(action?.data?.PostalCodeMappingId)"></dx-button>-->

<!--                <dx-button-->
<!--                        *ngIf="action?.data?.ModifiedByUserId <= 0 && action?.data?.MappingModeId == 0"-->
<!--                        class="mr-1"-->
<!--                        icon="fa fa-check fa-1x"-->
<!--                        hint="Accept"-->
<!--                        (onClick)="accept(action?.data?.PostalCodeMappingId)"-->
<!--                ></dx-button>-->
<!--                <dx-button-->
<!--                        class="mr-1"-->
<!--                        *ngIf="action?.data?.ModifiedByUserId > 0 && action?.data?.ModifiedByUserId != currentUser?.UserId && action?.data?.ReviewedByUserId == -1"-->
<!--                        icon="fas fa-check-double fa-1x"-->
<!--                        hint="Review"-->
<!--                        (onClick)="review(action?.data?.PostalCodeMappingId)"-->
<!--                ></dx-button>-->
                <dx-button
                        *ngIf="currentUser.UserRoleId > 1 && !action?.data?.Active"
                        icon="fas fa-trash-restore fa-1x"
                        hint="Activate"
                        (onClick)="reactivate(action?.data?.PostalCodeMappingId)"></dx-button>
                <dx-button
                        *ngIf="currentUser.UserRoleId > 1 && action?.data?.Active"
                        icon="fas fa-trash-alt fa-1x"
                        hint="Deactivate"
                        (onClick)="deactivate(action?.data?.PostalCodeMappingId)"></dx-button>
            </div>

<!--            <div *dxTemplate="let data of 'detail'">-->
<!--                <div class="master-detail-caption"></div>-->
<!--                <app-transaction-detail [key]="data.key"></app-transaction-detail>-->
<!--            </div>-->
            <dxo-paging [pageSize]="5"></dxo-paging>
            <dxo-master-detail
                    [enabled]="true"
                    template="masterDetail"
            ></dxo-master-detail>

            <div *dxTemplate="let masterDetailItem of 'masterDetail'">
                <app-postal-code-detail-view
                        [key]="masterDetailItem.key"
                ></app-postal-code-detail-view>
            </div>
            <!-- <dxo-summary [calculateCustomSummary]="calculateSummary">
                <dxi-total-item
                    name="totalMappingItemCount"
                    summaryType="custom"
                    showInColumn="PostalCodeMappingId"
                    displayFormat="Count: {0}">
                </dxi-total-item>
            </dxo-summary> -->
        </dx-data-grid>
    </div>
</div>

<div class="" *ngIf="isLoadPostalCodeMasterGridDataSource">
    <div dragula="HANDLES" id="left">
        <div class="mapping-grid-container shadow-lg mt-2">
            <span class="handle"><i class="fa fa-arrows" aria-hidden="true"></i></span>
            <div class="py-2 h-full">
                <dx-data-grid
                    #postalCodeMappingToMasterDataGrid
                    id="postalCodeMappingToMasterDataGrid"
                    [allowColumnResizing]="true"
                    [columnResizingMode]="'widget'"
                    [allowColumnReordering]="true"
                    [dataSource]="postalCodeMappingToMasterData"
                    [showBorders]="true"
                    [columnAutoWidth]="true"
                    [cacheEnabled]="false"
                    keyExpr="CurrentMappingModeId">
                    <dxo-load-panel
                            [enabled]="false"
                            shadingColor="rgba(0,0,0,0.4)"
                            [showIndicator]="true"
                            [showPane]="true"
                            [shading]="true">
                    </dxo-load-panel>
                    <dxi-column dataField="MappingSource" caption="Mappings"></dxi-column>
                    <dxi-column caption="Action" cellTemplate="action" alignment="center"></dxi-column>
                    <dxi-column dataField="MappingModeName"></dxi-column>
                    <dxi-column dataField="PostalCodeMasterId" [customizeText]="customizePostalCodeMasterId"></dxi-column>
                    <dxi-column dataField="PostalSystemGeographicalEntityCountryAlpha2Code" caption="Postal System Code"></dxi-column>
                    <dxi-column dataField="PostalSystemGeographicalEntityShortName" caption="Postal System Name"></dxi-column>
                    <dxi-column dataField="PostalSystemGeographicalEntityId" [visible]="false"></dxi-column>
                    <dxi-column dataField="PostalCode"></dxi-column>
                    <dxi-column dataField="PostalCodeTypeName" caption="Postal Code Type"></dxi-column>
                    <dxi-column dataField="PostalCodeTypeKey" [visible]="false"></dxi-column>
                    <dxi-column dataField="PostalCodeTypeId" [visible]="false"></dxi-column>
                    <dxi-column dataField="PostalCodeGeographicalName" caption="Postal Code Location"></dxi-column>
                    <dxi-column dataField="BaseLevelGeographicalNameOrCode" caption="Postal Code Country Subdivision"></dxi-column>
                    <dxi-column dataField="CountryLevelGeographicalNameOrCode" caption="Postal Code Country"></dxi-column>
                    <dxi-column dataField="PostalCodeInUse"></dxi-column>
                    <dxi-column dataField="CountryLevelGeographicalEntityShortName" caption="Master Country"></dxi-column>
                    <dxi-column dataField="CountryLevelGeographicalEntityCountrySubdivisionCode" [visible]="false"></dxi-column>
                    <dxi-column dataField="CountryLevelGeographicalEntityId" [visible]="false"></dxi-column>
                    <dxi-column dataField="BaseLevelGeographicalEntityShortName" caption="Master Country Subdivision"></dxi-column>
                    <dxi-column dataField="BaseLevelGeographicalEntityCountrySubdivisionParentCode" [visible]="false"></dxi-column>
                    <dxi-column dataField="BaseLevelGeographicalEntityCountrySubdivisionCode" [visible]="false"></dxi-column>
                    <dxi-column dataField="BaseLevelGeographicalEntityId" [visible]="false"></dxi-column>
                    <dxi-column dataField="PostalCodeMasterIsActive" [visible]="false"></dxi-column>

                    <div *dxTemplate="let action of 'action'">
                        <dx-button
                                id="btnOmit"
                                *ngIf="action?.data?.Ranking == -1"
                                class="mr-1"
                                icon="fas fa-ban fa-1x"
                                hint="Omit"
                                [disabled]="action?.data?.CurrentMappingModeId == 3"
                                (onClick)="omit(action?.data?.PostalCodeMappingId)"></dx-button>
                        <dx-button
                                id="btnSave"
                                *ngIf="action?.data?.Ranking == -1"
                                class="mr-1"
                                icon="far fa-bookmark fa-1x"
                                hint="Save"
                                [disabled]="action?.data?.CurrentMappingModeId == 2"
                                (onClick)="save(action?.data?.PostalCodeMappingId)"></dx-button>
                        <dx-button
                                id="btnAccept"
                                *ngIf="action?.data?.Ranking == -1 && !(postalCodeMappingSelectedRowData.ModifiedByUserId > 0 || (action?.data?.CurrentMappingModeId == 0 && action?.data?.CurrentPostalCodeMasterId == 0))"
                                class="mr-1"
                                icon="fa fa-check fa-1x"
                                hint="Accept"
                                (onClick)="accept(action?.data?.PostalCodeMappingId)"></dx-button>
<!--                         need icon-->
                        <dx-button
                                id="btnReview"
                                *ngIf="
                                action?.data?.Ranking == -1 &&
                                currentUser.UserRoleId > 1 &&
                                postalCodeMappingSelectedRowData.MappingModeId !== 0 &&
                                postalCodeMappingSelectedRowData.ModifiedByUserId > 0 &&
                                postalCodeMappingSelectedRowData.ModifiedByUserId !== currentUser.UserId &&
                                postalCodeMappingSelectedRowData.ReviewedByUserId == -1"
                                class="mr-1"
                                icon="fas fa-check-double fa-1x"
                                hint="Review"
                                (onClick)="review(action?.data?.PostalCodeMappingId)"></dx-button>
                        <dx-button
                                id="btnAcceptOmit"
                                *ngIf="action?.data?.Ranking >= 0 && action?.data?.MappingModeId == 3 && (action?.data?.Ranking > 0 || action?.data?.IsValidBarcode) && action?.data?.CurrentMappingModeId !== 3"
                                class="mr-1"
                                icon="fas fa-ban fa-1x"
                                hint="Accept Omit"
                                (onClick)="omit(action?.data?.PostalCodeMappingId)"></dx-button>
<!--                         need icon-->
                        <dx-button
                                id="btnAcceptSave"
                                *ngIf="action?.data?.Ranking >= 0 && action?.data?.MappingModeId == 2 && (action?.data?.Ranking > 0 || action?.data?.IsValidBarcode) && action?.data?.CurrentMappingModeId !== 2"
                                class="mr-1"
                                icon="far fa-bookmark fa-1x"
                                hint="Accept Save"
                                (onClick)="save(action?.data?.PostalCodeMappingId)"></dx-button>
                        <!-- need icon -->
<!--                        <dx-button-->
<!--                                id="btnAcceptMapping"-->
<!--                                *ngIf="action?.data?.Ranking >= 0 && action?.data?.MappingModeId == 1 && (action?.data?.PostalCodeMasterId && action?.data?.PostalCodeMasterId != 0) && action?.data?.CurrentPostalCodeMasterId !== action?.data?.PostalCodeMasterId"-->
<!--                                class="mr-1"-->
<!--                                icon="fas fa-map-marker-alt fa-1x"-->
<!--                                hint="Accept Mapping"-->
<!--                                (onClick)="acceptMapping(action?.data?.PostalCodeMasterId)"></dx-button>-->
                        <!-- need icon -->
                    </div>
                </dx-data-grid>
            </div>
        </div>
        <div class="mapping-grid-container shadow-lg mt-2">
            <div class="flex">
                <span class="handle mr-3"><i class="fa fa-arrows" aria-hidden="true"></i></span>
            </div>
            <div class="mt-2 h-full">
                <!-- <div class="flex justify-start">
                    <dx-check-box [value]="false" text="Switch to editable mode" class="pr-2" (onValueChanged)="switchToEditableMode()"></dx-check-box>
                </div> -->
                <dx-data-grid
                    #postalCodeMasterDataGrid
                    id="gridContainer2"
                    [allowColumnResizing]="true"
                    [columnResizingMode]="'widget'"
                    [allowColumnReordering]="true"
                    [dataSource]="postalCodeMasterDataSource"
                    [showBorders]="true"
                    [columnAutoWidth]="true"
                    [remoteOperations]="true"
                    [hoverStateEnabled]="true"
                    [cacheEnabled]="false"
                    [(selectedRowKeys)]="postalCodeMasterSelectedRowMap"
                    (onSelectionChanged)="masterGridSelectionChangedHandler()"
                    (onContextMenuPreparing)="postalCodeMasterDataGridContextMenu($event)"
                >
                    <dxo-state-storing
                            [enabled]="true"
                            type="custom"
                            [customLoad]="loadMasterState"
                            [customSave]="saveMasterState">
                    </dxo-state-storing>
                    <dxo-load-panel
                            [enabled]="false"
                            shadingColor="rgba(0,0,0,0.4)"
                            [showIndicator]="true"
                            [showPane]="true"
                            [shading]="true">
                    </dxo-load-panel>
                    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
                    <dxo-selection mode="single"></dxo-selection>
                    <dxo-column-chooser
                            [enabled]="true"
                            mode="dragAndDrop"> <!-- or "select" -->
                    </dxo-column-chooser>
                    <dxo-pager
                            [visible]="true"
                            [allowedPageSizes]="[5, 10, 25, 50, 100]"
                            displayMode="compact"
                            [showPageSizeSelector]="true"
                            [showNavigationButtons]="false"
                    >
                    </dxo-pager>

                    <dxo-search-panel
                            [visible]="true"
                            [(text)]="searchText"
                    ></dxo-search-panel>
                    <!-- <dxo-sorting mode="none"></dxo-sorting> -->
                    <dxi-column dataField="PostalCodeMasterId" [customizeText]="customizePostalCodeMasterId" [allowEditing]="false" [allowHeaderFiltering]="false"></dxi-column>
                    <dxi-column caption="Action" [allowHeaderFiltering]="false" cellTemplate="action" [width]="100" alignment="center"></dxi-column>
                    <dxi-column dataField="ReportRegionList">
                        <dxo-header-filter [dataSource]="reportRegionListHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="PostalCode">
                        <dxo-header-filter [dataSource]="postalCodeHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="PostalCodeTypeName">
                        <dxo-header-filter [dataSource]="postalCodeTypeNameHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="PostalCodeGeographicalName" caption="Postal Code Location">
                        <dxo-header-filter [dataSource]="postalCodeGeographicalNameHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="PostalCodeBaseLevelGeographicalNameOrCode" caption="Postal Code Country Subdivision">
                        <dxo-header-filter [dataSource]="postalCodeBaseLevelGeographicalNameOrCodeHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="PostalCodeCountryLevelGeographicalNameOrCode" caption="Postal Code Country">
                        <dxo-header-filter [dataSource]="postalCodeCountryLevelGeographicalNameOrCodeHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="PostalCodeInUse"></dxi-column>
                    <dxi-column dataField="CountrySubdivisionTypeName">
                        <dxo-header-filter [dataSource]="countrySubdivisionTypeNameMasterGridHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="CountrySubdivisionShortName">
                        <dxo-header-filter [dataSource]="countrySubdivisionShortNameMasterGridHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="CountrySubdivisionParentTypeName">
                        <dxo-header-filter [dataSource]="countrySubdivisionParentTypeNameMasterGridHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="CountrySubdivisionParentShortName">
                        <dxo-header-filter [dataSource]="countrySubdivisionParentShortNameMasterGridHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="CountrySubdivisionParentCode">
                        <dxo-header-filter [dataSource]="countrySubdivisionParentCodeMasterGridHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="CountrySubdivisionCode">
                        <dxo-header-filter [dataSource]="countrySubdivisionCodeMasterGridHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="CountryShortName">
                        <dxo-header-filter [dataSource]="countryShortNameHeaderMasterGridDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="CountryAlpha3Code">
                        <dxo-header-filter [dataSource]="countryAlpha3CodeHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="CountryAlpha2Code">
                        <dxo-header-filter [dataSource]="countryAlpha2CodeHeaderMasterGridDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="PostalCodeTypeId" [visible]="false">
                        <dxo-header-filter [dataSource]="postalCodeTypeIdHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="CountrySubdivisionGeographicalEntityId">
                        <dxo-header-filter [dataSource]="countrySubdivisionGeographicalEntityIdMasterGridHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="CountryGeographicalEntityId">
                        <dxo-header-filter [dataSource]="countryGeographicalEntityIdMasterGridHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="Longitude" [visible]="false">
                        <dxo-header-filter [dataSource]="longitudeHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="Latitude" [visible]="false">
                        <dxo-header-filter [dataSource]="latitudeHeaderDataSource"></dxo-header-filter>
                    </dxi-column>

<!--                    Delete-->
<!--                    <dxi-column caption="Data Auditing">-->
<!--                        <dxi-column dataField="ModifiedByUserFullNameSortableOrPrincipalName" caption="Modified by">-->
<!--                            <dxo-header-filter [dataSource]="modifiedByUserFullNameSortableOrPrincipalNameMasterGridHeaderDataSource"></dxo-header-filter>-->
<!--                        </dxi-column>-->
<!--                        <dxi-column dataField="ModifiedOn" cssClass="hide-filter-icon" caption="Modified On" [visible]="false" format="d/M/yyyy, HH:mm" dataType="datetime" [customizeText]="dateTimeFieldCustomization">-->
<!--                            <dxo-header-filter [dataSource]="modifiedOnMasterGridHeaderDataSource"></dxo-header-filter>-->
<!--                        </dxi-column>-->
<!--                        <dxi-column dataField="ReviewedByUserFullNameSortableOrPrincipalName" caption="Reviewed by">-->
<!--                            <dxo-header-filter [dataSource]="reviewedByUserFullNameSortableOrPrincipalNameMasterGridHeaderDataSource"></dxo-header-filter>-->
<!--                        </dxi-column>-->
<!--                        <dxi-column dataField="ReviewedOn" cssClass="hide-filter-icon" caption="Reviewed on" [visible]="false" format="d/M/yyyy, HH:mm" dataType="datetime" [customizeText]="dateTimeFieldCustomization">-->
<!--                            <dxo-header-filter [dataSource]="reviewedOnMasterGridHeaderDataSource"></dxo-header-filter>-->
<!--                        </dxi-column>-->
<!--                        <dxi-column dataField="CreatedOn" dataType="date" format="d/M/yyyy, HH:mm" dataType="datetime" cssClass="hide-filter-icon" [customizeText]="dateTimeFieldCustomization">-->
<!--                            <dxo-header-filter [dataSource]="createdOnMasterGridHeaderDataSource"></dxo-header-filter>-->
<!--                        </dxi-column>-->
<!--                        <dxi-column dataField="CreatedByUserFullNameSortableOrPrincipalName" caption="Created by" [visible]="false">-->
<!--                            <dxo-header-filter [dataSource]="createdByUserFullNameSortableOrPrincipalNameMasterGridHeaderDataSource"></dxo-header-filter>-->
<!--                        </dxi-column>-->
<!--                    </dxi-column>-->
                    <div *dxTemplate="let action of 'action'">
                        <dx-button
                                class="mr-1"
                                icon="fas fa-map-marker-alt fa-1x"
                                hint="Map"
                                (onClick)="map(action?.data?.PostalCodeMasterId)"></dx-button>
                    </div>
                    <dxo-paging [pageSize]="5"></dxo-paging>
                    <!-- <dxo-pager
                        [showPageSizeSelector]="true"
                        [allowedPageSizes]="[8, 12, 20]"
                    ></dxo-pager> -->
                </dx-data-grid>
            </div>
        </div>
    </div>
</div>
